import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Audiovisual = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="90" viewBox="0 0 77 90" width="77" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="m71.56 29.8-2.59 9.14a3 3 0 0 1-3.72 2.1l-15.86-4.47-15.78-4.48-15.07-4.28-2.66-.75a3.03 3.03 0 0 1-2.1-3.72l2.6-9.19a3 3 0 0 1 3.72-2.05l13.13 3.72 15.07 4.25 15.78 4.47 5.43 1.53a3 3 0 0 1 2.05 3.72Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M64.36 39.05h-51.3a3 3 0 0 0-3.02 3.02v39.17a3 3 0 0 0 3.02 3.02h51.3a3 3 0 0 0 3.02-3.02V42.07a3 3 0 0 0-3.02-3.02Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M27.99 9.47 13.3 21.46l-2.66-.75A3.03 3.03 0 0 1 8.55 17l2.6-9.19a3 3 0 0 1 3.72-2.06L28 9.47Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M43.05 13.73 28.37 25.75l-15.06-4.3L27.99 9.48z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M58.83 18.2 44.15 30.21l-15.78-4.47 14.68-12.02z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m66.31 23.44-2.59 9.15A3 3 0 0 1 60 34.7l-15.86-4.5 14.68-12 5.43 1.53a3 3 0 0 1 2.05 3.72z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M21.7 48.24H4.8V35.72a3 3 0 0 1 3-3.02h5.4z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M62.13 48.24V74.9a3 3 0 0 1-3.02 3.02H7.81a3 3 0 0 1-3.02-3.02V48.24z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M36.99 48.24H21.7L13.2 32.7h15.3z" fill={shades.primary.medium} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M52.27 48.24H37L28.5 32.7h15.3z" fill={shades.white} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M62.13 35.72v12.52h-9.86L43.8 32.7h15.32a3 3 0 0 1 3.02 3.02z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path d="M42.32 57.52V69.8h-6.15v-6.15h-6.15v6.15h-6.14V57.5z" fill={shades.black} />
    </svg>
  );
};
